export enum EAthenaCrudStatus {
	SUCCESS = 'SUCCESS',
	PROCESSING = 'PROCESSING'
}

export enum AthenaCrudRequestStatus {
	IN_PROGRESS = 0,
	WAITING_FOR_APPROVAL = 1,
	APPROVED = 2,
	REJECTED = 3,
	FAILED = 4
}

export enum AthenaCrudAction {
	APPROVE = 'APPROVE',
	REJECT = 'REJECT',
	EDIT = 'EDIT',
	ADD = 'ADD',
	VIEW = 'VIEW',
	VERSION_HISTORY = 'VERSION_HISTORY'
}

export const AthenaCrudActionLabel: { [key in AthenaCrudAction]: string } = {
	[AthenaCrudAction.APPROVE]: 'Approve',
	[AthenaCrudAction.REJECT]: 'Reject',
	[AthenaCrudAction.EDIT]: 'Edit',
	[AthenaCrudAction.ADD]: 'Add',
	[AthenaCrudAction.VIEW]: 'View',
	[AthenaCrudAction.VERSION_HISTORY]: 'Version History'
};
